	/*
	 * Enable click event for the Programs filter buttons
	 */
	exports.setupProgramsFilterWidget = function (WidgetuuID, DefaultFilterBy) {
		var lstMainSelectors = ['#campus_' + WidgetuuID],
			lstOtherSelectors = ['#category_' + WidgetuuID];

		var $campusFilter = $('#campus_' + WidgetuuID);
		var $categoryFilter = $('#category_' + WidgetuuID);

		// Activate Click event under the filter buttons
		$('#Btncategory_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);
			ShowHideElements(lstMainSelectors,lstOtherSelectors, true);
			refreshProgramsFilterWidget(WidgetuuID, ($campusFilter.val() > 0)? 'CampusID=' + $campusFilter.val() : null);
		});

		$('#Btncampus_' + WidgetuuID).click(function () {
			FusionDivBoutonsGroup(this);
			ShowHideElements(lstMainSelectors,lstOtherSelectors, false);
			refreshProgramsFilterWidget(WidgetuuID, ($categoryFilter.val() > 0)? 'WebTagID=' + $categoryFilter.val() : null);
		});

		$('#campus_' + WidgetuuID).change(function () {
			refreshProgramsFilterWidget(WidgetuuID,((this.value.length > 0) ? 'CampusID=' + this.value : ''));
		});
		$('#category_' + WidgetuuID).change(function () {
			refreshProgramsFilterWidget(WidgetuuID, ((this.value.length > 0) ? 'WebTagID=' + this.value : ''));
		});

		ShowHideElements(lstMainSelectors,lstOtherSelectors, (DefaultFilterBy == 'category'));
	};

	/*
	 * Refresh the Program/course listing when we change the filters (Campus or category)
	 */
	function refreshProgramsFilterWidget(WidgetuuID, filter) {
		var mode = $('#Btncategory_' + WidgetuuID).hasClass('selected') ? "category" : "Campus";
		var url =  (mode == "category") ?  window.lcb.config.apiPaths.ProgramCourseTags : window.lcb.config.apiPaths.ProgramCampuses;
		var language = $("meta[name='language-id']").attr('content');

		LoadApiData(url, 'LangID=' + language + '&HavePublishPage=1&' + filter, { onSuccess: function (data) {
		  	LoadUnderscoreTemplate(window.lcb.config.templatePaths.ProgramCategories,data, {
																						onSuccess: function(html){
																							LoadTemplateDiv('#divProgramContainer_'+WidgetuuID,html, {
																								pagination: false
																							});
																							$(document).foundation();

																							$('#divProgramNoResults_'+WidgetuuID).toggleClass("hide",(data.totalResults > 0));
																						}
																					  });

		}});
	}